// eslint-disable-next-line no-restricted-imports
import { OptionTypeBase, Select as ArcSelect, SelectProps } from 'arc';
import { forwardRef } from 'react';
import { GroupBase, SelectInstance } from 'react-select';
import { useInputSizeForApplicationType } from '../common/hooks/use-input-size-for-application-type';

export const Select = forwardRef(function <
    OptionType extends OptionTypeBase,
    Multi extends boolean = false
>(
    props: SelectProps<OptionType, Multi>,
    ref?: React.Ref<SelectInstance<unknown, false, GroupBase<unknown>> | undefined>
) {
    const { size: propsSize, ...otherProps } = props;
    const size = useInputSizeForApplicationType(propsSize);
    return <ArcSelect {...otherProps} ref={ref} size={size} />;
});
